'use client'

import { ArrowUpRightIcon, MailIcon, PhoneIcon } from 'lucide-react'
import { Button } from '@/components/ui/button'
import Link from 'next/link'

export function FeaturesSection() {
  return null
}

export function ContactSection() {
  return null
}

export function CallToAction() {
  return (
    <section className="py-24 bg-[#0d1117] border-t border-[#1c2333]">
      <div className="container mx-auto px-4 text-center">
        <p className="text-xs font-mono tracking-widest text-[#00c8ff] uppercase mb-6">
          Work With Us
        </p>
        <h2 className="text-4xl md:text-5xl font-bold text-[#e2e8f0] tracking-tight mb-6">
          If you run physical operations <br className="hidden md:block" />
          at scale, we should talk.
        </h2>
        <p className="text-[#94a3b8] max-w-lg mx-auto mb-10 text-lg">
          Property managers, transit authorities, governments. If you&apos;re
          managing complexity with manual processes —{' '}
          <span className="text-[#e2e8f0]">
            we&apos;ve built the replacement.
          </span>
        </p>

        <div className="flex flex-wrap justify-center gap-4 mb-12">
          <Link href="/contact">
            <Button
              size="lg"
              className="bg-[#00c8ff] text-[#07090f] font-semibold hover:bg-[#00b8ef] transition-colors"
            >
              Book a Discovery Call{' '}
              <ArrowUpRightIcon className="ml-2 h-4 w-4" />
            </Button>
          </Link>
        </div>

        <div className="flex flex-wrap justify-center gap-8 text-sm text-[#94a3b8]">
          <a
            href="mailto:sales@tidycalls.com"
            className="flex items-center gap-2 hover:text-[#e2e8f0] transition-colors"
          >
            <MailIcon className="h-4 w-4 text-[#00c8ff]" />
            sales@tidycalls.com
          </a>
          <a
            href="tel:+14157874640"
            className="flex items-center gap-2 hover:text-[#e2e8f0] transition-colors"
          >
            <PhoneIcon className="h-4 w-4 text-[#00c8ff]" />
            (+1) 415-787-4640
          </a>
        </div>
      </div>
    </section>
  )
}
